<template>
  <div class="main-container">
    <div class="disabled-items-modal">
      <div class="disabled-items-modal__icon" @click="closeModal">
        <svg
          class="disabled-items-modal__image svg-inline--fa"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            stroke="currentColor"
            stroke-linecap="square"
            stroke-width="2"
            d="M1.368 1.368l13.264 13.264m0-13.264L1.368 14.632"
          />
        </svg>
      </div>
      <div class="disabled-items-modal__body">
        <div class="disabled-items-modal__items">
          <app-notifier
            v-for="(message, index) in messages"
            :key="index"
            class="checkout__error"
            :type="'failed'"
            :data="message"
          />
          <vendor-menu-item-default
            v-for="(item, index) in disabledItems"
            :key="`${item.id}-${index}`"
            :menu-item="item"
            unavailable
            hide-price
          >
          </vendor-menu-item-default>
        </div>
        <div class="d-flex flex-space-between confirmation-buttons">
          <app-button :text="'OK'" :aria-label="'OK'" :handler="handleOK" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VendorMenuItemDefault from "@/routes/menu/components/menu-list/menu-item/templates/VendorMenuItemDefault";
import { DISABLED_ITEMS_MODAL_TEXT } from "@/../app-constants";

export default {
  name: "DisabledItemsModal",
  components: {
    VendorMenuItemDefault
  },
  props: {
    routeTo: {
      type: String,
      default: ""
    },
    showAlcoholMessage: {
      type: Boolean,
      default: false
    },
    showItemsMessage: {
      type: Boolean,
      default: false
    },
    disabledItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      messages: []
    };
  },
  mounted() {
    this.showMessages();
  },
  methods: {
    showMessages() {
      if (this.showItemsMessage) this.messages.push(DISABLED_ITEMS_MODAL_TEXT.itemsChangedMessage);
      if (this.showAlcoholMessage) this.messages.push(DISABLED_ITEMS_MODAL_TEXT.alcoholChangedMessage);
    },
    handleOK() {
      this.closeModal();
    },
    closeModal() {
      this.$modal.hide("DisabledItemsModal");
      if (this.routeTo) this.$router.push({ name: this.routeTo });
    }
  }
};
</script>

<style lang="scss" scoped>
.dark {
  a:link {
    color: #ffffff;
  }
  a:visited {
    color: #ffffff;
  }
}

.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.disabled-items-modal {
  display: flex;
  justify-content: left;
  flex-flow: column;
  align-items: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: $theme2__fontFamilyPrimary;
  color: $text-color;
  padding: 30px;
  @include respond-to-mobile {
    padding: 10px 20px;
  }

  &__icon {
    align-self: flex-end;
    cursor: pointer;
    padding: 15px 5px 10px;
  }

  &__items {
    width: calc(100% - 80px);
    margin-left: 40px;
    margin-right: 40px;
    margin-top: 40px;
    margin-bottom: 25px;

    @include respond-to-mobile {
      margin-left: 27px;
      margin-right: 27px;
      width: calc(100% - 54px);
    }
  }

  &__body {
    display: block;
    font-size: 20px;
    font-weight: 100;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.65;
    letter-spacing: normal;
    width: 100%;
    margin-bottom: 45px;

    .menu-item {
      pointer-events: none;
    }

    @include respond-to-mobile {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
    }

    .confirmation-buttons {
      button:nth-of-type(1) {
        margin-right: 10px;
      }
    }
  }

  &__header {
    margin-top: 50px;
  }
  &__strong {
    font-weight: bold;
  }
  &__notifier {
    display: block;
    width: 100%;
  }
}
</style>
